import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete } from "./axiosFunctions";

const getCashCardFormUrl                   = '/api/admin/cashCard/getCashCardForm';
const getCashCardListUrl                   = (userId) => `/api/admin/cashCard/getCashCardList/${userId}`;
const postCashCardUrl                      = '/api/admin/cashCard/postCashCard';
const deleteCashCardUrl                    = (id) => `/api/admin/cashCard/deleteCashCard/${id}`

export const getCashCardForm = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getCashCardFormUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getCashCardList = async (userId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getCashCardListUrl(userId),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};    

export const postCashCard = async (cashCardMaster) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postCashCardUrl, { cashCardMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const deleteCashCard = async (id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteCashCardUrl(id),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

